import { Injectable } from '@angular/core';

export type Theme = 'light' | 'dark' | 'system';

@Injectable({
  providedIn: 'root'
})
export class DarkThemeService {

  constructor() {
    // Apply the theme as soon as the service is created
    this.applyTheme();
  }

  /**
   * Apply the current theme from localStorage or system settings.
   * @param theme Optional theme override ('light', 'dark', or 'system')
   */
  applyTheme(theme?: Theme): void {
    if (theme) {
      if (theme === 'system') {
        localStorage.removeItem('theme');
      } else {
        localStorage.setItem('theme', theme);
      }
    }
    const storedTheme = localStorage.getItem('theme');
    // If the stored theme is 'dark' OR if no preference is stored and the OS prefers dark,
    // then we consider dark mode active.
    const isDark = storedTheme === 'dark' ||
      (!storedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches);
    document.documentElement.classList.toggle('dark', isDark);
  }

  /**
   * Change the theme and update the document.
   * @param theme 'light', 'dark', or 'system'
   */
  setTheme(theme: Theme): void {
    this.applyTheme(theme);
  }
}
